<template>
  <div class="v-full-screen-loader">
    Loading...
  </div>
</template>

<style lang="scss" scoped>
.v-full-screen-loader {
}
</style>
